<template>
  <!-- ===== 服务器租赁板块 ===== -->
  <section class="rental-section">
    <div class="rental-bg">
      <div class="rental-orb rental-orb-1"></div>
      <div class="rental-orb rental-orb-2"></div>
    </div>
    <div class="section-header">
      <!-- <span class="section-badge">🖥️ 算力租赁</span> -->
      <h2 class="section-title">
        {{ $t("serverList.title1")
        }}<span class="highlight">{{ $t("serverList.title2") }}</span>
      </h2>
      <p class="section-desc">{{ $t("serverList.desc") }}</p>
    </div>

    <div class="rental-grid">
      <!-- 合并两个列表，统一渲染 -->
      <template v-for="serverList in [serverTopList, serverHotList]">
        <div
          class="rental-card rental-highlight"
          v-for="server in serverList"
          :key="server.id"
        >
          <div class="rental-card-badges">
            <div class="rental-card-badges">
              <span
                v-if="server.highlight > 0"
                :class="['badge', getHighlightClass(server.highlight)]"
              >
                {{ getHighlightText(server.highlight) }}
              </span>
              <!-- 状态标签 -->
              <!-- <span
            v-if="getServerStatus(server) === STATUS.pending"
            class="badge status-badge status-badge-pending"
            >⏳ {{ $t("serverList.btnWait") }}</span
          >
          <span
            v-else-if="getServerStatus(server) === STATUS.preOrder"
            class="badge status-badge status-badge-preorder"
            >🔥 {{ $t("serverList.btnRent") }}</span
          >
          <span
            v-else-if="getServerStatus(server) === STATUS.active"
            class="badge status-badge status-badge-active"
            >⚡ {{ $t("serverList.yunxz") }}</span
          > -->
            </div>
            <!-- <span style="color: #4b5056">{{ $t("detail.code") }}{{ server.code }}</span> -->
            <div>
              <img
                v-if="server.country_img"
                :src="server.country_img"
                :alt="$t('rental.countryAlt')"
                class="country-flag"
              />
            </div>
          </div>
          <!-- 推荐标签 -->
          <!-- 服务器名称 -->
          <div class="rental-header">
            <ServerIconIsometric size="sm" />

            <h3 class="rental-name">{{ $t(server.code + ".s_model") }}</h3>
            <!-- <span class="rental-spec">{{ ServerSpec?.[server.spec] }}</span> -->
          </div>

          <!-- 核心数据 - 固定宽度 -->
          <div class="rental-stats">
            <div
              class="rental-stat"
              style="min-width: 60px"
              v-if="isServerActive(server)"
            >
              <span class="rental-stat-label">{{
                $t("serverList.dailyIncome")
              }}</span>
              <span class="rental-stat-value rental-price"
                >${{ server.today_income }}</span
              >
            </div>
            <div class="rental-divider" v-if="isServerActive(server)"></div>
            <div class="rental-stat" style="min-width: 60px">
              <span class="rental-stat-label">{{
                $t("serverList.value")
              }}</span>
              <span class="rental-stat-value">${{ server.value }}</span>
            </div>
            <div class="rental-divider" v-if="server.yield"></div>
            <div
              class="rental-stat"
              style="min-width: 50px"
              v-if="server.yield"
            >
              <span class="rental-stat-label">{{
                $t("serverList.yield")
              }}</span>
              <span class="rental-stat-value rental-yield">{{
                server.yield
              }}</span>
            </div>
          </div>

          <!-- 价值进度条 -->
          <div class="rental-value-progress">
            <!-- <div class="value-header">
            <div class="value-info">
              <span class="value-label">价值进度</span>
            </div> 
            <span class="value-progress-text">
              {{ calcValueProgress(server) }}%
            </span>
          </div> -->

            <!-- 进度条 -->
            <div class="progress-track">
              <div
                class="progress-bar"
                v-if="isServerActive(server)"
                :style="`width: ${calcValueProgress(server)}%`"
              >
                <span class="progress-glow"></span>

                <span class="progress-box" v-if="isServerActive(server)">
                  {{ calcValueProgress(server) }}%
                </span>
              </div>
            </div>

            <!-- <div class="value-footer">
            <span class="value-remaining">
              剩余
              <strong>${{ calcValueAmount(server) }}</strong>
            </span>
          </div> -->
          </div>

          <!-- 额外信息 - 固定宽度 -->
          <div class="rental-details">
            <div class="rental-detail-item">
              <span class="rental-detail-label">GPU</span>
              <span class="rental-detail-value">{{
                $t(server.code + ".s_core")
              }}</span>
            </div>
            <div class="rental-detail-item">
              <span class="rental-detail-label">{{
                $t("serverList.vram")
              }}</span>
              <span class="rental-detail-value">{{
                $t(server.code + ".s_vram")
              }}</span>
            </div>
            <div class="rental-detail-item">
              <span class="rental-detail-label">{{
                $t("serverList.storage")
              }}</span>
              <span class="rental-detail-value">{{
                $t(server.code + ".s_ssd")
              }}</span>
            </div>
            <div class="rental-detail-item">
              <span class="rental-detail-label">{{
                $t("serverList.status")
              }}</span>
              <span
                class="rental-detail-value"
                :class="getServerStatusClass(server)"
                style="min-width: 56px"
              >
                {{ getServerStatusText(server) }}
              </span>
            </div>
          </div>

          <!-- 等待预售开始 -->
          <div
            v-if="getServerStatus(server) === STATUS.pending"
            class="pending-tech"
          >
            <!-- 悬浮倒计时条 -->
            <div class="countdown-tech-bar">
              <div style="margin-top: 82%">
                <!-- 左侧：标签 + 倒计时 -->
                <div class="tech-left">
                  <span class="tech-label">
                    <span class="tech-dot"></span>
                    {{ $t("serverList.countdown") }}
                  </span>
                  <span class="tech-digits">{{
                    formatCountdown(server.start_time)
                  }}</span>
                </div>
              </div>
              <!-- 按钮 -->
              <button
                class="btn-rental btn-tech"
                :class="getServerStatusClass(server)"
                @click="handleRental(server)"
              >
                <span class="btn-tech-text">{{
                  getServerStatusBtn(server)
                }}</span>
              </button>
            </div>
          </div>

          <!-- 预售中 -->
          <div v-if="getServerStatus(server) === STATUS.preOrder">
            <button
              class="btn-rental"
              :class="getServerStatusClass(server)"
              @click="handleRental(server)"
            >
              {{ getServerStatusBtn(server) }}
            </button>

            <!-- 倒计时 -->
            <!-- <div class="countdown-box">
            <span class="countdown-label">{{ $t("serverList.over") }}</span>
            <span class="countdown-time">{{
              formatCountdown(server.begin_time)
            }}</span>
          </div> -->
          </div>

          <!-- 运行中 -->
          <div v-if="getServerStatus(server) === STATUS.active">
            <button
              class="btn-rental"
              :class="getServerStatusClass(server)"
              @click="handleRental(server)"
            >
              {{ getServerStatusBtn(server) }}
            </button>
          </div>

          <!-- 周期结束 -->
          <div v-if="getServerStatus(server) === STATUS.ended">
            <button
              class="btn-rental"
              :disabled="false"
              :class="getServerStatusClass(server)"
              @click="handleRental(server)"
            >
              {{ getServerStatusBtn(server) }}
            </button>
          </div>
        </div>
      </template>
    </div>

    <!-- ===== 更多产品按钮 ===== -->
    <div class="more-products">
      <button class="btn-more" @click="handleMoreProducts">
        <span class="btn-more-text">{{ $t("serverList.more") }}</span>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </section>
</template>

<script>
const STATUS = {
  pending: "pending",
  preOrder: "preOrder",
  active: "active",
  ended: "ended",
};
const ServerSpec = {
  1: "serverList.spec1",
  2: "serverList.spec2",
  3: "serverList.spec3",
  4: "serverList.spec4",
};

const ServerHighlightMap = {
  1: {
    textKey: "serverList.tagHot",
    class: "badge-hot",
  },
  2: {
    textKey: "serverList.tagRecommend",
    class: "badge-recommend",
  },
  3: {
    textKey: "serverList.tagNew",
    class: "badge-available",
  },
};
import { loadProductsLanguage } from "@/locales";
import ServerIconIsometric from "@/components/server/ServerIconIsometric.vue";
export default {
  components: {
    ServerIconIsometric,
  },
  data() {
    return {
      STATUS,
      ServerSpec,
      serverTopList: [],
      serverHotList: [],
      now: this.$dayjs().valueOf(),
      countdownTimer: null,
    };
  },
  created() {
    this.getServerTop("top");
    this.getServerTop("hot");

    // 启动倒计时定时器，每秒更新
    this.countdownTimer = setInterval(() => {
      this.now = this.$dayjs().valueOf();
    }, 1000);
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
  watch: {
    "$i18n.locale": function (newLang, oldLang) {
      console.log(`语言从 ${oldLang} 切换到 ${newLang}`);
      // 重新加载产品翻译（如果切换到的新语言还没有该产品翻译）
      this.loadProductTranslations();
    },
  },
  computed: {},
  methods: {
    async loadProductTranslations() {
      //批量加载产品翻译
      const codes = this.serverTopList
        .concat(this.serverHotList)
        .map((p) => p.code);
      await loadProductsLanguage(codes, {
        path: "server/",
        module: "server",
      });
    },
    getServerTop(typ) {
      this.$api.server
        .getServerTop({ typ })
        .then((res) => {
          if (res.code === 0) {
            if (typ === "top") {
              this.serverTopList = res.data || [];
            } else if (typ === "hot") {
              this.serverHotList = res.data || [];
            }
            this.loadProductTranslations();
          }
        })
        .catch((err) => {
          console.error("获取服务器列表失败:", err);
        });
    },

    // ===== 判断服务器状态 =====
    // pending: 未开始（倒计时中）
    // active: 进行中（可租赁）
    // ended: 已结束（不可租赁）
    getServerStatus(server) {
      const now = this.$dayjs();
      // 服务器时间统一按美国东部时区（America/New_York，自动处理夏令时）解析，
      // 不随浏览器本地时区变化，保证各浏览器判断结果一致
      const startTime = server.start_time
        ? this.$dayjs(server.start_time)
        : null;
      const beginTime = server.begin_time
        ? this.parseServerTime(server.begin_time)
        : null;
      const endTime = server.end_time
        ? this.parseServerTime(server.end_time)
        : null;

      // 没有时间信息，默认按 status 判断
      if (!startTime && !beginTime) {
        return server.status == 2 ? STATUS.active : STATUS.ended;
      }

      // 未到开始时间
      if (startTime && now.isBefore(startTime)) {
        return STATUS.pending;
      }

      // 预售开始
      if (beginTime && now.isBefore(beginTime)) {
        return STATUS.preOrder;
      }

      //已过结束时间
      if (endTime && now.isAfter(endTime)) {
        return STATUS.ended;
      }

      return STATUS.active;
    },
    // 按美国东部时区解析服务器时间
    // 无时区的 "MM/DD/YYYY HH:mm" / "YYYY-MM-DD HH:mm:ss" → 转 ISO 后按 America/New_York 解析（自动处理夏令时）
    parseServerTime(str) {
      if (!str) return null;
      const m = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}:\d{2})/);
      if (m) {
        const iso = `${m[3]}-${m[1].padStart(2, "0")}-${m[2].padStart(
          2,
          "0",
        )}T${m[4]}:00`;
        return this.$dayjs.tz(iso, "America/New_York");
      }
      if (
        /^\d{4}-\d{2}-\d{2}/.test(str) &&
        !/[Zz]|[+-]\d{2}:\d{2}$/.test(str)
      ) {
        return this.$dayjs.tz(str, "America/New_York");
      }
      // 带时区偏移（如 -04:00）/ 时间戳 → 按绝对时刻解析
      return this.$dayjs(str);
    },
    //状态
    isServerActive(server) {
      return this.getServerStatus(server) !== STATUS.pending;
    },
    //返回class
    getServerStatusClass(server) {
      // 等待预购中
      if (this.getServerStatus(server) === STATUS.pending) {
        return STATUS.pending;
      }

      // 预购中
      if (
        this.getServerStatus(server) === STATUS.preOrder &&
        this.calcValueProgress(server) < 100
      ) {
        return STATUS.preOrder;
      }

      // 运行中
      if (this.getServerStatus(server) === STATUS.active) {
        return STATUS.active;
      }

      return STATUS.ended;
    },
    //返回状态文字
    getServerStatusText(server) {
      //已结束
      if (this.getServerStatus(server) === STATUS.ended) {
        return this.$t("serverList.btnEnded");
      }

      //等待预购中
      if (this.getServerStatus(server) === STATUS.pending) {
        return this.$t("serverList.btnWait");
      }

      //运行中
      if (this.getServerStatus(server) === STATUS.active) {
        return this.$t("serverList.yunxz");
      }

      //已满额
      if (this.calcValueProgress(server) >= 100) {
        return this.$t("serverList.full");
      }

      //预购中
      if (this.getServerStatus(server) === STATUS.preOrder) {
        return this.$t("serverList.available");
      }

      //已满额
      return this.$t("serverList.full");
    },

    //返回状态文字
    getServerStatusBtn(server) {
      //已结束
      if (this.getServerStatus(server) === STATUS.ended) {
        return this.$t("serverList.btnEnded");
      }

      //等待预购中
      if (this.getServerStatus(server) === STATUS.pending) {
        return this.$t("serverList.look");
      }

      //运行中
      if (this.getServerStatus(server) === STATUS.active) {
        return this.$t("serverList.yunxz");
      }

      //已满额
      if (this.calcValueProgress(server) >= 100) {
        return this.$t("serverList.full");
      }

      //预购中
      if (this.getServerStatus(server) === STATUS.preOrder) {
        return this.$t("serverList.btnRent");
      }

      //已满额
      return this.$t("serverList.full");
    },

    // ===== 格式化倒计时 =====
    formatCountdown(time) {
      const beginTime = time ? this.$dayjs(time).valueOf() : null;
      if (!beginTime) return "";

      const diff = beginTime - this.now;
      if (diff <= 0) return "00:00:00";

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const pad = (n) => String(n).padStart(2, "0");

      if (days > 0) {
        return `${days}${this.$t("serverList.days")} ${pad(hours)}:${pad(
          minutes,
        )}:${pad(seconds)}`;
      }
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    },
    getHighlightText(highlight) {
      const key = ServerHighlightMap[highlight]?.textKey;
      return key ? this.$t(key) : "";
    },
    getHighlightClass(highlight) {
      return ServerHighlightMap[highlight]?.class || "";
    },
    calcValueProgress(item) {
      const rate = (1 - (item.surplus - item.sale)) * 100;
      if (!rate) return 0;
      return Math.min(rate.toFixed(4), 100);
    },
    calcValueAmount(item) {
      const amount = (item.surplus - item.sale) * item.value;
      if (!amount) return 0;
      return Math.max(Math.round(amount), 0);
    },
    handleRental(server) {
      this.$router.push({
        name: "RentalDetail",
        query: {
          code: server.code,
        },
      });
    },
    handleMoreProducts() {
      // 跳转到产品列表页
      this.$router.push("/rental");
      // 或者触发事件
      // this.$emit('more-products');
    },
  },
};
</script>

<style scoped>
/* ============================================================
   服务器租赁板块
   ============================================================ */
.rental-section {
  padding: 80px 20px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0e1a, #141b2d);
}

.rental-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.rental-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.08;
}

.rental-orb-1 {
  width: 400px;
  height: 400px;
  background: #f7971e;
  top: -100px;
  right: -100px;
}

.rental-orb-2 {
  width: 300px;
  height: 300px;
  background: #7c3aed;
  bottom: -100px;
  left: -50px;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
  position: relative;
  z-index: 1;
}

.section-badge {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.1);
  color: #00b4ff;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 12px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px 0;
}

.section-title .highlight {
  background: linear-gradient(135deg, #f7971e, #ffd200);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.section-desc {
  color: rgba(255, 255, 255, 0.4);
  font-size: 16px;
  margin: 0;
}

/* ===== 卡片网格 ===== */
.rental-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  position: relative;
  z-index: 1;
}

/* ===== 卡片 ===== */
.rental-card {
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 20px 18px 18px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0;
}

.rental-card:hover {
  transform: translateY(-4px);
  border-color: rgba(0, 180, 255, 0.15);
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.rental-highlight {
  border-color: rgba(255, 215, 0, 0.2);
  background: linear-gradient(
    135deg,
    rgba(255, 215, 0, 0.04),
    rgba(0, 180, 255, 0.04)
  );
}

.rental-highlight:hover {
  border-color: rgba(255, 215, 0, 0.3);
}

/* ============================================================
   三种状态卡片差异化设计
   ============================================================ */

/* ===== 等待预售开始 - 蓝色科技风 ===== */
.card-status-pending {
  border-color: rgba(0, 180, 255, 0.25);
  background: linear-gradient(
    160deg,
    rgba(0, 180, 255, 0.06),
    rgba(0, 10, 30, 0.4) 60%
  );
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.08),
    inset 0 1px 0 rgba(0, 180, 255, 0.08);
}

.card-status-pending:hover {
  border-color: rgba(0, 180, 255, 0.4);
  box-shadow: 0 8px 40px rgba(0, 180, 255, 0.15),
    inset 0 1px 0 rgba(0, 180, 255, 0.1);
}

/* 顶部蓝色光带 */
.card-status-pending::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 180, 255, 0.6),
    transparent
  );
  border-radius: 16px 16px 0 0;
  animation: status-pending-glow 2.5s ease-in-out infinite;
}

@keyframes status-pending-glow {
  0%,
  100% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }
}

/* ===== 预售中 - 橙色/金色系 ===== */
.card-status-preorder {
  border-color: rgba(255, 152, 0, 0.3);
  background: linear-gradient(
    160deg,
    rgba(255, 152, 0, 0.07),
    rgba(30, 20, 0, 0.4) 60%
  );
  box-shadow: 0 0 30px rgba(255, 152, 0, 0.1),
    inset 0 1px 0 rgba(255, 152, 0, 0.08);
}

.card-status-preorder:hover {
  border-color: rgba(255, 152, 0, 0.45);
  box-shadow: 0 8px 40px rgba(255, 152, 0, 0.18),
    inset 0 1px 0 rgba(255, 152, 0, 0.1);
}

/* 顶部橙色光带 */
.card-status-preorder::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 152, 0, 0.7),
    transparent
  );
  border-radius: 16px 16px 0 0;
  animation: status-preorder-glow 2s ease-in-out infinite;
}

@keyframes status-preorder-glow {
  0%,
  100% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }
}

/* ===== 运行中 - 绿色系 ===== */
.card-status-active {
  border-color: rgba(0, 201, 81, 0.25);
  background: linear-gradient(
    160deg,
    rgba(0, 201, 81, 0.05),
    rgba(0, 20, 10, 0.4) 60%
  );
  box-shadow: 0 0 30px rgba(0, 201, 81, 0.08),
    inset 0 1px 0 rgba(0, 201, 81, 0.08);
}

.card-status-active:hover {
  border-color: rgba(0, 201, 81, 0.4);
  box-shadow: 0 8px 40px rgba(0, 201, 81, 0.15),
    inset 0 1px 0 rgba(0, 201, 81, 0.1);
}

/* 顶部绿色光带 */
.card-status-active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 201, 81, 0.6),
    transparent
  );
  border-radius: 16px 16px 0 0;
  animation: status-active-glow 3s ease-in-out infinite;
}

@keyframes status-active-glow {
  0%,
  100% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }
}

/* ===== 状态标签 ===== */
.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 8px;
  letter-spacing: 0.3px;
}

.status-badge-pending {
  background: rgba(0, 180, 255, 0.12);
  color: #00b4ff;
  border: 1px solid rgba(0, 180, 255, 0.2);
}

.status-badge-preorder {
  background: rgba(255, 152, 0, 0.12);
  color: #ff9800;
  border: 1px solid rgba(255, 152, 0, 0.25);
  animation: preorder-pulse 2s ease-in-out infinite;
}

@keyframes preorder-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 rgba(255, 152, 0, 0);
  }

  50% {
    box-shadow: 0 0 12px rgba(255, 152, 0, 0.2);
  }
}

.status-badge-active {
  background: rgba(0, 201, 81, 0.12);
  color: #00c951;
  border: 1px solid rgba(0, 201, 81, 0.2);
}

/* ===== 标签 ===== */
.rental-card-badges {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.badge {
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-hot {
  background: rgba(255, 152, 0, 0.15);
  color: #ff9800;
}

.badge-available {
  background: rgba(0, 201, 81, 0.12);
  color: #00c951;
}

.badge-sold {
  background: rgba(255, 107, 107, 0.12);
  color: #ff6b6b;
}

.badge-recommend {
  background: rgb(255 235 59 / 11%);
  color: #ffeb3b;
}

/* ===== 头部 ===== */
.rental-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  min-height: 44px;
}

.rental-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(0, 180, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00b4ff;
  flex-shrink: 0;
}

.rental-name {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  min-width: 80px;
  /* max-width: 120px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
}

.rental-spec {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.04);
  padding: 2px 10px;
  border-radius: 12px;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
}

/* ===== 核心数据 ===== */
.rental-stats {
  display: flex;
  align-items: stretch;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  padding: 10px 6px;
  margin-bottom: 14px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.rental-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  padding: 0 2px;
  min-width: 50px;
  justify-content: center;
}

.rental-stat-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.25);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.rental-stat-value {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  font-family: "SF Mono", "Courier New", monospace;
  white-space: nowrap;
}

.rental-price {
  color: #ffd866;
  font-size: 17px;
}

.rental-yield {
  color: #00c951;
}

.rental-divider {
  width: 1px;
  background: rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

/* ===== 价值进度条 ===== */
.rental-value-progress {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.value-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.value-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.value-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.value-progress-text {
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.progress-track {
  position: relative;
  width: 100%;
  height: 15px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 4px;
  overflow: visible;
}

.progress-bar {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, #00b4ff, #7c3aed);
  position: relative;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.progress-glow {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background: radial-gradient(circle, rgba(0, 180, 255, 0.4), transparent 70%);
  border-radius: 50%;
  animation: glow-pulse 2s ease-in-out infinite;
}

@keyframes glow-pulse {
  0%,
  100% {
    opacity: 0.6;
    transform: translateY(-50%) scale(1);
  }

  50% {
    opacity: 1;
    transform: translateY(-50%) scale(1.3);
  }
}

.value-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.03);
}

.value-remaining {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.3);
}

.value-remaining strong {
  color: #ffd866;
  font-weight: 700;
}

/* ===== 详情信息 ===== */
.rental-details {
  display: grid;
  gap: 2px 12px;
  margin-bottom: 14px;
  padding: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.rental-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
  gap: 8px;
  overflow: hidden;
}

.rental-detail-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.25);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
  min-width: 28px;
}

.rental-detail-value {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 40px;
  flex-shrink: 1;
}

.rental-detail-value.preOrder {
  color: #00c951;
}

.rental-detail-value.active {
  color: #00c951;
}

.rental-detail-value.ended {
  color: #ff6b6b;
}

.available-blue {
  color: #0068ff;
}

.available-no {
  color: #ff6b6b;
}

/* ===== 倒计时 ===== */
.countdown-box {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 10px;
  border-radius: 10px;
  background: rgba(255, 152, 0, 0.08);
  border: 1px solid rgba(255, 152, 0, 0.15);
}

.countdown-label {
  font-size: 12px;
  color: rgba(255, 152, 0, 0.7);
  font-weight: 500;
  white-space: nowrap;
}

.countdown-time {
  font-size: 15px;
  font-weight: 800;
  color: #ff9800;
  font-family: "SF Mono", "Courier New", monospace;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* ===== 按钮 ===== */
.btn-rental {
  width: 100%;
  padding: 10px 0;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  white-space: nowrap;
  cursor: pointer;
}

.btn-rental:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 100, 255, 0.3);
}

.btn-rental:disabled {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.2);
  cursor: not-allowed;
}

/* ===== 已满额按钮（红色系） ===== */
.btn-rental.btn-full {
  background: rgba(255, 107, 107, 0.12);
  color: #ff6b6b;
  border: 1px solid rgba(255, 107, 107, 0.2);
  cursor: not-allowed;
}

/* ===== 更多产品按钮 ===== */
.more-products {
  display: flex;
  justify-content: center;
  margin-top: 48px;
  position: relative;
  z-index: 1;
}

.btn-more {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 40px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-more:hover {
  border-color: rgba(0, 180, 255, 0.3);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 180, 255, 0.05);
}

.btn-more-text {
  white-space: nowrap;
}

.btn-more svg {
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.btn-more:hover svg {
  transform: translateX(4px);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1024px) {
  .rental-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .rental-section {
    padding: 40px 16px;
  }

  .section-title {
    font-size: 28px;
  }

  .rental-grid {
    grid-template-columns: 1fr;
    max-width: 400px;
  }

  .rental-stats {
    flex-wrap: wrap;
    gap: 4px 0;
  }

  .rental-divider {
    display: none;
  }

  .rental-stat {
    flex: 1 1 45%;
    padding: 2px 0;
    min-width: 60px;
  }

  .rental-details {
    grid-template-columns: 1fr;
    gap: 2px 0;
  }

  .rental-detail-item {
    justify-content: space-between;
  }

  .rental-detail-value {
    white-space: nowrap;
    max-width: 120px;
  }

  .rental-card-badges {
    margin-bottom: 8px;
  }

  .badge {
    font-size: 12px;
    padding: 2px 8px;
  }

  .rental-name {
    max-width: 100px;
  }

  .btn-more {
    padding: 12px 24px;
    font-size: 14px;
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 380px) {
  .rental-name {
    max-width: 70px;
    font-size: 14px;
  }

  .rental-stat-value {
    font-size: 13px;
  }

  .rental-price {
    font-size: 15px;
  }
}

.progress-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

/* ============================================================
   等待预售开始 - 科技风设计
   ============================================================ */

.pending-tech {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  z-index: 10;
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  height: 100%;
  padding: 0;
  pointer-events: none;
}

.pending-tech .countdown-tech-bar {
  pointer-events: auto;
}

/* 状态标签在 pending 覆盖层之上 */
.rental-card .rental-card-badges {
  position: relative;
  z-index: 10;
}

/* ===== 预售中 - 倒计时样式 ===== */
.card-status-preorder .countdown-box {
  background: rgba(255, 152, 0, 0.1);
  border-color: rgba(255, 152, 0, 0.2);
}

.card-status-preorder .countdown-label {
  color: rgba(255, 152, 0, 0.8);
}

.card-status-preorder .countdown-time {
  color: #ff9800;
}

/* ===== 运行中 - 倒计时样式 ===== */
.card-status-active .countdown-box {
  background: rgba(0, 201, 81, 0.08);
  border-color: rgba(0, 201, 81, 0.15);
}

.card-status-active .countdown-label {
  color: rgba(0, 201, 81, 0.7);
}

.card-status-active .countdown-time {
  color: #00c951;
}

/* ===== 预售中 - 进度条样式 ===== */
.card-status-preorder .progress-track {
  background: rgba(255, 152, 0, 0.08);
}

.card-status-preorder .progress-bar {
  background: linear-gradient(90deg, #ff9800, #ff6d00);
}

/* ===== 运行中 - 进度条样式 ===== */
.card-status-active .progress-track {
  background: rgba(0, 201, 81, 0.08);
}

.card-status-active .progress-bar {
  background: linear-gradient(90deg, #00c951, #00a843);
}

/* ===== 倒计时条 ===== */
.countdown-tech-bar {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  background: rgba(0, 10, 30, 0.6);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(0, 180, 255, 0.12);
  border-radius: 12px;
  padding: 10px 16px 10px 18px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(0, 180, 255, 0.05);
  height: 100%;
}

/* 边框光效 */
.countdown-tech-bar::before {
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: 12px;
  padding: 1px;
  background: linear-gradient(
    135deg,
    rgba(0, 180, 255, 0.15),
    transparent 40%,
    rgba(124, 58, 237, 0.1)
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

/* 顶部扫描线 */
.countdown-tech-bar::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 180, 255, 0.3),
    transparent
  );
  animation: scan-line 4s ease-in-out infinite;
}

@keyframes scan-line {
  0% {
    left: -100%;
  }

  50% {
    left: 100%;
  }

  100% {
    left: 100%;
  }
}

/* 底部微光 */
.countdown-tech-bar .tech-glow {
  position: absolute;
  bottom: -20px;
  right: 20px;
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(0, 180, 255, 0.04), transparent 70%);
  pointer-events: none;
}

/* ===== 左侧 ===== */
.tech-left {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 14px;
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.tech-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 500;
  color: rgba(0, 180, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  white-space: nowrap;
  flex-shrink: 0;
}

.tech-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00b4ff;
  box-shadow: 0 0 12px rgba(0, 180, 255, 0.3);
  animation: dot-pulse 1.5s ease-in-out infinite;
}

@keyframes dot-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.3;
    transform: scale(0.7);
  }
}

.tech-digits {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  font-family: "SF Mono", "JetBrains Mono", "Courier New", monospace;
  letter-spacing: 2px;
  background: linear-gradient(90deg, #fff, rgba(0, 180, 255, 0.7));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 40px rgba(0, 180, 255, 0.05);
}

/* ===== 右侧：进度环 ===== */
.tech-right {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.tech-ring {
  position: relative;
  width: 48px;
  height: 48px;
}

.tech-ring svg {
  display: block;
}

.tech-ring .ring-percent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 180, 255, 0.6);
  font-family: "SF Mono", monospace;
  letter-spacing: 0.5px;
}

/* ===== 按钮 ===== */
.btn-rental.btn-tech {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  color: rgb(255 255 255);
  /* border: 1px solid rgba(0, 180, 255, 0.06); */
  border-radius: 10px;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 500;
  cursor: default;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  overflow: hidden;
  margin-bottom: 6px;
}

/* .btn-rental.btn-tech:hover {
  background: #2196f3;
  border-color: rgba(0, 180, 255, 0.1);
} */

.btn-tech-text {
  opacity: 0.8;
  letter-spacing: 0.5px;
}

.btn-tech-line {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.06);
}

.btn-tech-icon {
  font-size: 14px;
  opacity: 0.6;
  transition: all 0.3s ease;
}

/* .btn-rental.btn-tech:hover .btn-tech-icon {
  opacity: 0.6;
} */

/* 满额状态 */
.btn-rental.btn-tech.btn-full {
  background: rgba(255, 107, 107, 0.04);
  border-color: rgba(255, 107, 107, 0.06);
  color: rgba(255, 107, 107, 0.3);
}

.btn-rental.btn-tech.btn-full .btn-tech-line {
  background: rgba(255, 107, 107, 0.1);
}

/* ===== 响应式 ===== */
@media (max-width: 640px) {
  .pending-tech {
    margin-top: -14px;
  }

  .countdown-tech-bar {
    padding: 8px 12px 8px 14px;
    border-radius: 10px;
  }

  .tech-left {
    gap: 10px;
  }

  .tech-label {
    font-size: 9px;
    letter-spacing: 1px;
  }

  .tech-dot {
    width: 5px;
    height: 5px;
  }

  .tech-digits {
    font-size: 18px;
    letter-spacing: 1.5px;
  }

  .tech-ring {
    width: 40px;
    height: 40px;
  }

  .tech-ring svg {
    width: 40px;
    height: 40px;
  }

  .tech-ring .ring-percent {
    font-size: 8px;
  }

  .btn-rental.btn-tech {
    padding: 8px 0;
    font-size: 13px;
  }
}

@media (max-width: 380px) {
  .tech-digits {
    font-size: 15px;
    letter-spacing: 1px;
  }

  .tech-label {
    font-size: 8px;
    letter-spacing: 0.5px;
  }

  .tech-left {
    gap: 6px;
  }

  .tech-ring {
    width: 34px;
    height: 34px;
  }

  .tech-ring svg {
    width: 34px;
    height: 34px;
  }

  .tech-ring .ring-percent {
    font-size: 7px;
  }

  .btn-rental.btn-tech {
    font-size: 12px;
    padding: 7px 0;
  }

  .btn-tech-line {
    display: none;
  }
}

/* ============================================================
   科技蓝统一配色（覆盖重载）
   - STATUS.pending  → 灰色（等待中，低调处理）
   - STATUS.preOrder → 品牌蓝（预售中）
   - STATUS.active   → 品牌蓝（运行中）
   去除过亮的橙/绿/黄，统一为冷色科技蓝
   ============================================================ */

/* ---------- 背景光球：橙色 → 科技蓝 ---------- */
.rental-orb-1 {
  background: #1e3a8a;
}

/* ---------- 标题高亮：橙金 → 蓝紫 ---------- */
.section-title .highlight {
  background: linear-gradient(135deg, #60a5fa, #818cf8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ---------- 推荐卡片边框：金色 → 蓝色 ---------- */
.rental-highlight {
  border-color: rgba(96, 165, 250, 0.18);
  background: linear-gradient(
    135deg,
    rgba(96, 165, 250, 0.04),
    rgba(0, 180, 255, 0.04)
  );
}

.rental-highlight:hover {
  border-color: rgba(96, 165, 250, 0.3);
}

/* ==================== pending = 灰色 ==================== */
.card-status-pending {
  border-color: rgba(148, 163, 184, 0.22);
  background: linear-gradient(
    160deg,
    rgba(148, 163, 184, 0.05),
    rgba(15, 20, 30, 0.4) 60%
  );
  box-shadow: 0 0 30px rgba(148, 163, 184, 0.05),
    inset 0 1px 0 rgba(148, 163, 184, 0.06);
}

.card-status-pending:hover {
  border-color: rgba(148, 163, 184, 0.35);
  box-shadow: 0 8px 40px rgba(148, 163, 184, 0.1),
    inset 0 1px 0 rgba(148, 163, 184, 0.08);
}

.card-status-pending::before {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(148, 163, 184, 0.45),
    transparent
  );
}

/* pending 状态文字：蓝色 → 灰色 */
.available-blue {
  color: #8b95a5;
}

/* pending 倒计时覆盖层 → 灰色 */
.countdown-tech-bar {
  border-color: rgba(148, 163, 184, 0.14);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(148, 163, 184, 0.04);
}

.countdown-tech-bar::before {
  background: linear-gradient(
    135deg,
    rgba(148, 163, 184, 0.12),
    transparent 40%,
    rgba(148, 163, 184, 0.08)
  );
}

.countdown-tech-bar::after {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(148, 163, 184, 0.25),
    transparent
  );
}

.tech-label {
  color: rgba(148, 163, 184, 0.6);
}

.tech-dot {
  background: #8b95a5;
  box-shadow: 0 0 12px rgba(148, 163, 184, 0.25);
}

.tech-digits {
  background: linear-gradient(90deg, #fff, rgba(148, 163, 184, 0.7));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* pending 科技按钮 → 灰色 */
.btn-rental.btn-tech {
  background: linear-gradient(135deg, #6b7280, #4b5563);
}

/* pending 倒计时框 → 灰色 */
.countdown-box,
.card-status-preorder .countdown-box {
  background: rgba(148, 163, 184, 0.06);
  border-color: rgba(148, 163, 184, 0.12);
}

.countdown-label,
.card-status-preorder .countdown-label {
  color: rgba(148, 163, 184, 0.6);
}

.countdown-time,
.card-status-preorder .countdown-time {
  color: #94a3b8;
}

/* ============ preOrder & active = 品牌蓝 ============ */
.card-status-preorder,
.card-status-active {
  border-color: rgba(0, 180, 255, 0.28);
  background: linear-gradient(
    160deg,
    rgba(0, 180, 255, 0.06),
    rgba(0, 10, 30, 0.4) 60%
  );
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.08),
    inset 0 1px 0 rgba(0, 180, 255, 0.08);
}

.card-status-preorder:hover,
.card-status-active:hover {
  border-color: rgba(0, 180, 255, 0.42);
  box-shadow: 0 8px 40px rgba(0, 180, 255, 0.15),
    inset 0 1px 0 rgba(0, 180, 255, 0.1);
}

.card-status-preorder::before,
.card-status-active::before {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 180, 255, 0.6),
    transparent
  );
}

/* ---------- 状态标签 ---------- */
.status-badge-pending {
  background: rgba(148, 163, 184, 0.1);
  color: #94a3b8;
  border-color: rgba(148, 163, 184, 0.18);
}

.status-badge-preorder,
.status-badge-active {
  background: rgba(0, 180, 255, 0.12);
  color: #00b4ff;
  border-color: rgba(0, 180, 255, 0.2);
}

/* 预售标签闪烁 → 蓝色光晕 */
.status-badge-preorder {
  animation: preorder-pulse 2s ease-in-out infinite;
}

@keyframes preorder-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 rgba(0, 180, 255, 0);
  }

  50% {
    box-shadow: 0 0 12px rgba(0, 180, 255, 0.15);
  }
}

/* ---------- 营销徽章：橙/绿/黄 → 品牌蓝 ---------- */

.badge-sold {
  background: rgba(255, 107, 107, 0.1);
  color: #ff8f8f;
}

/* ---------- 数值颜色：金/绿 → 品牌蓝 ---------- */

.rental-yield {
  color: #00b4ff;
}

.value-remaining strong {
  color: #00b4ff;
}

.btn-rental.preOrder {
  background: linear-gradient(135deg, #00b4ff, #0068ff);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.2);
}

.btn-rental.active {
  background: linear-gradient(135deg, #00b4ff85, #0068ffa8);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.2);
}

.btn-rental.ended {
  background: linear-gradient(135deg, #6b7280, #4b5563);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.2);
}

/* ---------- active 倒计时 → 品牌蓝 ---------- */
.card-status-active .countdown-box {
  background: rgba(0, 180, 255, 0.08);
  border-color: rgba(0, 180, 255, 0.15);
}

.card-status-active .countdown-label {
  color: rgba(0, 180, 255, 0.7);
}

.card-status-active .countdown-time {
  color: #00b4ff;
}

/* ---------- preOrder & active 进度条 → 品牌蓝 ---------- */
.card-status-preorder .progress-track,
.card-status-active .progress-track {
  background: rgba(0, 180, 255, 0.08);
}

.card-status-preorder .progress-bar,
.card-status-active .progress-bar {
  background: linear-gradient(90deg, #00b4ff, #0068ff);
}

.country-flag {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
